var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,attrs:{"disabled":_vm.count === 0},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),_c('span',{class:_vm.countClasses},[_vm._v(_vm._s(_vm.count))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }